/**
 * Practical dBFS window for metering normalization.
 * Real levels sit roughly -50…-10 dB; mapping the full -160…0 range squashes
 * silence and speech into the same bar heights.
 */
const WAVEFORM_DB_FLOOR = -52;
const WAVEFORM_DB_CEIL = 0;

/**
 * Map metering dBFS to 0–1 for bar height.
 * Identical to rely-rn `normalizeMeteringTo01`.
 */
export function normalizeMeteringTo01(db) {
  if (typeof db !== 'number' || Number.isNaN(db)) {
    return 0;
  }
  const span = WAVEFORM_DB_CEIL - WAVEFORM_DB_FLOOR;
  const t = (db - WAVEFORM_DB_FLOOR) / span;
  const clamped = Math.min(1, Math.max(0, t));
  return clamped ** 1.15;
}
